// Home page slider
var swiper2 = new Swiper(".homebannerslider", {
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
    loop: true,
    autoplay: {
        delay: 3000, // 3 seconds ke baad slide change hogi
        disableOnInteraction: false, // user interaction ke baad bhi autoplay chalta rahe
    },
});